/**
 * NZG Newsletter-Popup — Trigger-Controller.
 *
 * Nicht-modale Promo-Karte (snippets/nzg-newsletter-popup.liquid). Zwilling der
 * Sprach-Karte (locale-suggestion.js). Entscheidet WANN die Karte erscheint und
 * verarbeitet die Anmeldung per Fetch (kein Full-Reload).
 *
 * Trigger (alles muss gelten):
 *  - nicht schon angemeldet, nicht innerhalb der Snooze-Frist, nicht schon in dieser Session gezeigt
 *  - Auslöser: 2. Pageview (nach Settle-Delay) ODER >=60% Scroll auf Produkt/Collection
 *    ODER Exit-Intent (nur Desktop)
 *  - im Moment des Zeigens darf weder die Sprach-Karte noch der CCM19-Cookie-Banner sichtbar sein
 *
 * Frequenz: Schließen = Snooze (Default 30 Tage), Anmeldung = nie wieder, sonst max. 1x/Session.
 *
 * Test: ?nzg_show_nl=1 erzwingt sofort, ?nzg_show_nl=reset löscht die Flags.
 */
(function () {
  'use strict';

  if (isBot(navigator.userAgent)) return;

  var KEY_SUBSCRIBED = 'nzg:nl-subscribed';
  var KEY_SNOOZE = 'nzg:nl-snooze';
  var KEY_SHOWN = 'nzg:nl-shown';     // sessionStorage, max 1x/Session
  var KEY_PV = 'nzg:nl-pv';           // sessionStorage Pageview-Zähler

  var override = (window.location.search.match(/[?&]nzg_show_nl=([^&]+)/) || [])[1];
  if (override === 'reset') {
    try {
      localStorage.removeItem(KEY_SUBSCRIBED);
      localStorage.removeItem(KEY_SNOOZE);
      sessionStorage.removeItem(KEY_SHOWN);
      sessionStorage.removeItem(KEY_PV);
    } catch (e) {}
  }

  var configEl = document.getElementById('nzg-nl-popup-config');
  var container = document.getElementById('nzg-nl-popup');
  if (!configEl || !container) return;

  var config;
  try { config = JSON.parse(configEl.textContent || '{}'); } catch (e) { config = {}; }

  var scrollThreshold = typeof config.scrollThreshold === 'number' ? config.scrollThreshold : 0.6;
  var minPageviews = typeof config.minPageviews === 'number' ? config.minPageviews : 2;
  var snoozeDays = typeof config.snoozeDays === 'number' ? config.snoozeDays : 30;
  var settleDelay = typeof config.settleDelay === 'number' ? config.settleDelay : 2500;
  var pageType = String(config.pageType || '');
  var forced = override === '1';

  var card = container.querySelector('.nzg-nl');
  var formState = container.querySelector('.nzg-nl__form-state');
  var successState = container.querySelector('.nzg-nl__success');
  var form = container.querySelector('#nzg-nl-form');
  var emailInput = container.querySelector('#nzg-nl-email');
  var cta = container.querySelector('.nzg-nl__cta');
  var errorEl = container.querySelector('[data-nl-error]');

  var shown = false;
  var deferTries = 0;

  // Pageview-Zähler dieser Session hochzählen.
  var pageviews = 1;
  try {
    pageviews = (parseInt(sessionStorage.getItem(KEY_PV) || '0', 10) || 0) + 1;
    sessionStorage.setItem(KEY_PV, String(pageviews));
  } catch (e) {}

  if (forced) {
    // Test-Anzeige darf das "1x/Session"-Flag NICHT setzen, sonst blockiert
    // ein einziger ?nzg_show_nl=1-Test den Auto-Trigger für den Rest der Session.
    reveal();
    bindClose();
    bindSubmit();
    return;
  }

  if (!eligible()) return;
  try { if (sessionStorage.getItem(KEY_SHOWN) === '1') return; } catch (e) {}

  bindClose();
  bindSubmit();

  // --- Trigger scharf schalten -----------------------------------------

  if (pageviews >= minPageviews) {
    setTimeout(attempt, settleDelay);
  }

  if (pageType === 'product' || pageType === 'collection') {
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (config.exitIntent !== false && matchMedia('(pointer: fine)').matches && window.innerWidth >= 750) {
    // Exit-Intent erst nach kurzer Verweildauer scharf schalten, damit ein
    // sofortiges Maus-Wegzucken beim Landen die Karte nicht direkt auslöst.
    setTimeout(function () { document.addEventListener('mouseout', onMouseOut); }, 4000);
  }

  // --- Logik ------------------------------------------------------------

  function onScroll() {
    var doc = document.documentElement;
    var scrolled = (window.scrollY || doc.scrollTop) + window.innerHeight;
    var height = doc.scrollHeight || document.body.scrollHeight;
    if (height > 0 && scrolled / height >= scrollThreshold) {
      window.removeEventListener('scroll', onScroll);
      attempt();
    }
  }

  function onMouseOut(e) {
    if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) {
      document.removeEventListener('mouseout', onMouseOut);
      attempt();
    }
  }

  function attempt() {
    if (shown || !eligible()) return;
    // Auf Sprach-Karte / Cookie-Banner kurz warten, aber NICHT endlos: nach ein
    // paar Versuchen trotzdem zeigen, sonst kommt die Karte nie, wenn der Besucher
    // den Cookie-Banner einfach stehen lässt (häufigster Fall bei Neukunden).
    if (bannersVisible() && deferTries < 8) {
      deferTries++;
      setTimeout(attempt, 800);
      return;
    }
    show();
  }

  function reveal() {
    container.hidden = false;
    container.setAttribute('data-visible', 'true');
  }

  function show() {
    if (shown) return;
    shown = true;
    try { sessionStorage.setItem(KEY_SHOWN, '1'); } catch (e) {}
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onMouseOut);
    reveal();
    // Kein Autofokus — sonst springt auf Mobile direkt die Tastatur auf.
  }

  function close() {
    container.hidden = true;
    container.removeAttribute('data-visible');
    try { localStorage.setItem(KEY_SNOOZE, String(Date.now())); } catch (e) {}
  }

  function eligible() {
    try {
      if (localStorage.getItem(KEY_SUBSCRIBED) === '1') return false;
      var snooze = parseInt(localStorage.getItem(KEY_SNOOZE) || '0', 10);
      if (snooze && (Date.now() - snooze) < snoozeDays * 86400000) return false;
    } catch (e) {}
    return true;
  }

  function bannersVisible() {
    return languageVisible() || ccmVisible();
  }

  function languageVisible() {
    var el = document.getElementById('nzg-locale-suggestion');
    return !!(el && !el.hidden && el.getAttribute('data-visible') === 'true');
  }

  // CCM19 (Pixelopment) Banner. Best-effort über bekannte Container-Selektoren —
  // wird nichts gefunden, gilt als "frei" (blockt nie fälschlich). Der echte
  // Schutz ist ohnehin der Engagement-Trigger: Banner erscheinen beim Entry,
  // unsere Karte erst nach 2. Pageview / tiefem Scroll.
  function ccmVisible() {
    try {
      var el = document.querySelector('#ccm-widget, .ccm-widget, #ccm19, .ccm-root, .ccm-modal, [data-ccm19]');
      if (!el) return false;
      var st = window.getComputedStyle(el);
      return st && st.display !== 'none' && st.visibility !== 'hidden' && el.offsetParent !== null;
    } catch (e) { return false; }
  }

  // --- Anmeldung --------------------------------------------------------

  function bindClose() {
    var btns = container.querySelectorAll('[data-action="close"]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (ev) { ev.preventDefault(); close(); });
    }
  }

  function bindSubmit() {
    if (!form) return;
    form.addEventListener('submit', function (ev) {
      if (emailInput && !emailInput.checkValidity()) {
        // Native Browser-Validierung übernimmt die Fehlermeldung.
        return;
      }
      ev.preventDefault();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (cta) cta.disabled = true;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(onSubmitSuccess).catch(onSubmitError);
    });
  }

  function onSubmitSuccess() {
    try { localStorage.setItem(KEY_SUBSCRIBED, '1'); } catch (e) {}
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
    // Selbst-Schließen nach dem Lesen.
    setTimeout(function () {
      container.hidden = true;
      container.removeAttribute('data-visible');
    }, 7000);
  }

  function onSubmitError() {
    if (cta) cta.disabled = false;
    if (errorEl) {
      errorEl.textContent = config.errorText || 'Something went wrong. Please try again.';
      errorEl.hidden = false;
    }
  }

  function isBot(ua) {
    if (!ua) return false;
    return /bot\b|crawler|spider|slurp|bingpreview|facebookexternalhit|whatsapp/i.test(ua);
  }
})();
